import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useStores } from "../hooks/use-stores";
import { observer } from "mobx-react-lite";


function ConfirmationModal() {
    const { commonStore } = useStores();
    let { confirmationRequired, confirmationDescription, confirmationAction
        , confirmationTitle, confirmationShowCancel, confirmationHtmlDescription
        , confirmationCancelTitle = 'Cancel', confirmationOptions } = commonStore;

    const onConfirm = async (arg) => {
        return commonStore.doConfirm(arg);
    };

    const renderAction = (confirmationAction, confirmationOptions={}) => {
        if ( confirmationAction == null ) return null;
        const disabled = confirmationOptions?.disabledOkButton === true || false;
        console.log("confirmationAction disabled", disabled);
        if (Array.isArray(confirmationAction)) {
            return confirmationAction.map((action, i) => (
                <Button
                    color={action.color || "primary"}
                    variant={action.variant}
                    key={i}
                    onClick={() => onConfirm(action.key)}
                // style={{marginTop:"0.5rem"}}
                >
                    {action.value}
                </Button>
            )
            );
        } else {
            return (
                <Button
                    disabled={disabled}
                    color="primary"
                    variant="contained"
                    onClick={onConfirm}
                // style={{marginTop:"0.5rem"}}
                >
                    {confirmationAction}
                </Button>
            );
        }
    };

    const handleClose = () => {
        commonStore.cancelConfirm();
    };

    return (
        confirmationRequired
        && <Dialog
            {...((confirmationOptions && confirmationOptions.dialogProps) || {}) }
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={true}
        >
            { (!confirmationOptions || !confirmationOptions.hideHeader) &&  <DialogTitle
                id="customized-dialog-title"
                onClose={handleClose}
            >
                {confirmationTitle}
            </DialogTitle>}
            {(confirmationHtmlDescription || confirmationDescription)  && <DialogContent dividers  {...((confirmationOptions && confirmationOptions.dialogContentProps) || {}) }>
                {confirmationHtmlDescription
                    ? <div dangerouslySetInnerHTML={{__html:confirmationDescription}}/>
                    : confirmationDescription }
            </DialogContent>}
            <DialogActions>
                {confirmationShowCancel &&
                    <Button
                        onClick={handleClose}
                        color="secondary"
                        variant="contained"
                    >
                        {confirmationCancelTitle}
                    </Button>
                }
                {renderAction(confirmationAction, confirmationOptions)}{' '}
            </DialogActions>
        </Dialog>
    );
}

export default observer(ConfirmationModal);